import { convertToCamelCaseFromUnderScore, formatDate } from '../../../../common-utilities/utils';
import { DATE_FORMATS } from '../../../../common-utilities/utils/constants';

export const formatReport = (results) => {
  return (
    results?.map?.((item) => {
      return {
        'Vendor Name': item?.name,
        'Vendor Code': item?.vendorCode,
        'Item Name': item?.item?.name,
        'Item Code': item?.item?.itemCode || null,
        Price: item?.price,
        'Tax Percentage': item?.taxPercentage ?? null,
        Status: `${convertToCamelCaseFromUnderScore(item?.status)} ${
          item?.approvalId?.pendingWith ? `(${item?.approvalId?.pendingWith})` : ''
        }`.trim(),
        'From Date': item?.fromDate ? formatDate(item.fromDate, DATE_FORMATS['DD-MM-YYYY']) : null,
        'To Date': item?.toDate ? formatDate(item.toDate, DATE_FORMATS['DD-MM-YYYY']) : null,
      };
    }) || []
  );
};
